import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  getLanguageType() {
    const storedLang = localStorage.getItem("lang");
    switch (storedLang) {
      case 'en':
        return 1;
      case 'fr':
        return 2;
      default:
        return 1;
    }
  }

  sideModules(id: any) {
    return this.http.get<any>(`${environment.apiUrl}/api/role/${id}`)
      .pipe(map(user => {
        return user;
      }));
  }

  getRoleList(
    pageNumber: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filterValue: any,
    filterColumn: any
) {
    const languageId = this.getLanguageType();

    // ✅ Always send valid sort values; only append search params when non-empty
    let url = `${environment.apiUrl}/api/role/getAll`
        + `?languageId=${languageId}`
        + `&page=${pageNumber}`
        + `&size=${pageSize}`
        + `&sortBy=${sortBy || 'roleId'}`
        + `&sortDir=${sortDir || 'desc'}`;

    if (filterValue)  url += `&searchKeyword=${filterValue}`;
    if (filterColumn) url += `&searchField=${filterColumn}`;

    return this.http.get<any>(url).pipe(map(res => res));
}

  getFunctionsByModuleId(userId: any, moduleId: any) {
    return this.http.get<any>(`${environment.apiUrl}/api/role/get-by-moduleId/${userId}/${moduleId}`)
      .pipe(map(res => {
        return res;
      }));
  }

  getRolePermission() {
    return this.http.get<any>(`${environment.apiUrl}/api/role/role-permissions?languageId=${this.getLanguageType()}`)
      .pipe(map(res => {
        return res;
      }));
  }

  saveRole(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/role/saveOrUpdateRoles`, payload)
      .pipe(map(response => {
        return response;
      }));
  }

  getFeaturesByFunctionId(userId: number, functionId: number) {
    return this.http.get(`${environment.apiUrl}/api/role/get-by-functionId/${userId}/${functionId}`)
      .pipe(map(res => {
        return res;
      }));
  }

  rolesDropdownList() {
    const languageId = this.getLanguageType();
    return this.http.get(`${environment.apiUrl}/api/role/rolesDropdownList/${languageId}`)
      .pipe(map(res => {
        return res;
      }));
  }

  manageUserRoles(assign: boolean, userIds: number[], roleIds: number[]): Observable<any> {
  return this.http.post<any>(
    `${environment.apiUrl}/api/role/manage-roles`,
    { assign, userIds, roleIds }
  );
}
}
